<template>
  <div class="page-content">
    <div
      :class="{ 'list-of-drivers': true, 'show-driver-list': showDriverList }"
    >
      <div class="card partner-card">
        <div class="card-header">
          List Of Drivers
          {{
            filteredActiveDriverList?.length > 0
              ? '(' + filteredActiveDriverList?.length + ')'
              : ''
          }}
          <div class="button-area">
            <button class="btn btn-sm btn-primary" @click="loadDriverList">
              <i class="bi bi-arrow-clockwise"></i>
            </button>
            <button
              class="btn btn-sm btn-secondary sidebar-toggle-btn"
              @click="showDriverList = !showDriverList"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
        <div class="card-body">
          <div
            class="partner-modal-section"
            v-if="selectedBackupTR?.length > 0"
          >
            <div class="partner-modal-info">
              <SelectedBackupTRVue
                :key="backupTRKey"
                @syncBackupTRs="syncBackupTRs"
              ></SelectedBackupTRVue>
              <div class="backup-request-btn-holder">
                <button
                  class="btn btn-xs btn-secondary"
                  @click="searchInPartnerPage()"
                >
                  Invite Partners
                </button>
                <button
                  class="btn btn-xs btn-primary"
                  v-if="checkedDriverDetails?.length > 0"
                  data-bs-toggle="modal"
                  data-bs-target="#invitePartnerModal"
                >
                  Invite
                </button>
              </div>
            </div>
          </div>
          <DefaultLoader v-if="isLoading"></DefaultLoader>
          <div v-else class="partner-modal-section">
            <div class="partner-modal-info">
              <div
                class="info-content"
                v-if="filteredActiveDriverList?.length > 0"
              >
                <d
                  iv
                  class="info-row"
                  v-for="(driver, index) in filteredActiveDriverList"
                  :key="index"
                >
                  <ul @click="zoomDriver(driver.userCode)">
                    <li>
                      <input
                        type="checkbox"
                        v-model="checkedDriverDetails"
                        :value="{
                          user_code: driver.userCode,
                          name: driverDetailsObj[driver.userCode]?.name
                            ? driverDetailsObj[driver.userCode].name
                            : null,
                          mobile: driverDetailsObj[driver.userCode]?.mobile
                            ? driverDetailsObj[driver.userCode].mobile
                            : null
                        }"
                        style="accent-color: #652f8f"
                      />
                      <span class="list-left-text">{{ driver.userCode }}</span>
                      <span class="list-right-text">{{
                        format.timeAgo(driver.created_at)
                      }}</span>
                    </li>
                    <li>
                      {{
                        driverDetailsObj[driver.userCode]?.name
                          ? driverDetailsObj[driver.userCode].name
                          : 'N/A'
                      }}
                    </li>
                    <li>
                      {{
                        driverDetailsObj[driver.userCode]?.mobile
                          ? driverDetailsObj[driver.userCode].mobile
                          : 'N/A'
                      }}
                    </li>
                    <li>
                      Car Type:
                      {{
                        driverCarInfoObj[driver.userCode]
                          ? driverCarInfoObj[driver.userCode]
                          : 'N/A'
                      }}
                    </li>
                    <li>
                      Garage Location:
                      {{
                        driverGarageLocations[driver.userCode]?.name
                          ? driverGarageLocations[driver.userCode].name
                          : 'N/A'
                      }}
                    </li>
                  </ul>
                </d>
              </div>
              <div class="info-content" v-else>
                <div class="info-row">
                  <p>No Drivers Found!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="map-holder">
      <div class="search-fields">
        <button
          class="btn btn-primary sidebar-toggle-btn"
          @click="showDriverList = !showDriverList"
        >
          <i class="bi bi-list"></i>
        </button>
        <select
          class="form-select"
          style="max-width: 100px"
          v-model="formValue.driverType"
        >
          <option value="">None</option>
          <option value="B2C">B2C</option>
          <option value="B2B">B2B</option>
        </select>
        <select
          class="form-select"
          style="max-width: 250px"
          v-model="formValue.activeStatus"
        >
          <option value="1">Online</option>
          <option value="5">5 minutes ago last seen</option>
          <option value="10">10 minutes ago last seen</option>
          <option value="15">15 minutes ago last seen</option>
          <option value="20">20 minutes ago last seen</option>
          <option value="30">30 minutes ago last seen</option>
          <option value="40">40 minutes ago last seen</option>
          <option value="50">50 minutes ago last seen</option>
          <option value="60">1 hour ago last seen</option>
        </select>
        <select
          class="form-select"
          style="max-width: 250px"
          v-model="formValue.garageLocation"
        >
          <option value="">Select Garage Location</option>
          <template v-for="(area, index) in areaList" :key="index">
            <option :value="area.id">{{ area.name }}</option>
          </template>
        </select>
        <input
          type="text"
          class="form-control"
          style="max-width: 240px"
          v-model="formValue.driverCode"
          placeholder="Search driver by user code"
        />
      </div>
      <div id="mapId"></div>
    </div>
  </div>

  <teleport to="body">
    <!-- Modal -->
    <div
      class="modal fade"
      id="invitePartnerModal"
      tabindex="-1"
      aria-labelledby="invitePartnerModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <InvitePartnersToBackupTRVue
          :key="invitePartnersToBackupTRKey"
          :selectedDriverDetails="checkedDriverDetails"
          @syncBackupTRs="syncBackupTRs"
          @refreshData="$router.push('/trip-request/backup/requests')"
        ></InvitePartnersToBackupTRVue>
      </div>
    </div>
  </teleport>
</template>

<script>
import { Loader } from 'google-maps';
import credentials from '../config/credentials.js';
import http from '@/config/axios';
import locationService from '@/config/axiosLocationService.js';
import userServiceAPI from '../store/userServiceAPI';
import format from '../store/format';
import SelectedBackupTRVue from '../components/partnerLocation/SelectedBackupTR.vue';
import InvitePartnersToBackupTRVue from '../components/partnerLocation/InvitePartnersToBackupTR.vue';

export default {
  components: {
    SelectedBackupTRVue,
    InvitePartnersToBackupTRVue
  },
  data() {
    return {
      isLoading: false,
      coordinates: {
        lat: 23.810431079332343,
        lng: 90.41242187756868
      },
      zoom: 13,
      google: '',
      map: null,
      markers: [],
      infoWindow: null,
      formValue: {
        driverType: '',
        activeStatus: 1,
        driverCode: '',
        garageLocation: ''
      },
      activeDriverList: [],
      filteredActiveDriverList: [],
      driverDetailsObj: {},
      selectedBackupTR: JSON.parse(localStorage.getItem('selectedBackupTR')),
      backupTRKey: 0,
      invitePartnersToBackupTRKey: 0,
      checkedDriverDetails: [],
      driverCarInfos: [],
      driverCarInfoObj: {},
      showDriverList: true,
      areaList: [],
      driverGarageLocations: {},
      format
    };
  },
  beforeMount() {
    this.loader = new Loader(credentials.GOOGLE_MAP_API_KEY, {
      libraries: ['places']
    });
  },
  mounted() {
    this.loadDriverList();
    this.getAreaList();
  },
  watch: {
    'formValue.driverType'() {
      this.loadDriverList();
    },
    'formValue.activeStatus'() {
      this.loadDriverList();
    },
    'formValue.garageLocation'() {
      this.loadDriverList();
    },
    'formValue.driverCode'() {
      this.searchDriver();
    }
  },
  methods: {
    async loadGoogleMap() {
      await this.loader.load().then((google) => {
        this.map = new google.maps.Map(document.getElementById('mapId'), {
          center: this.coordinates,
          zoom: this.zoom,
          mapTypeId: 'roadmap',
          gestureHandling: 'greedy'
        });
        this.google = google;
        this.infoWindow = new google.maps.InfoWindow({
          maxWidth: 200
        });
      });
    },
    async loadDriverList() {
      this.isLoading = true;
      await this.loadGoogleMap();

      locationService
        .get(
          `locations?last_seen=${this.formValue.activeStatus}&serviceType=${this.formValue.driverType}`
        )
        .then(async (response) => {
          this.activeDriverList = response.data.data;
          if (this.formValue.garageLocation) {
            await this.getUsersFromGarageLocation();
          }
          let activeDriverCodes = this.activeDriverList.map((driver) => {
            return driver.userCode;
          });
          await this.getDriverCarInfo(activeDriverCodes);
          await this.getGarageLocationsFromUsers(activeDriverCodes);

          userServiceAPI
            .getUserDetails(activeDriverCodes)
            .then((res) => {
              this.isLoading = false;
              this.driverDetailsObj = {};
              this.driverDetailsObj = userServiceAPI.mapUsersIntoObject(
                res.data?.data
              );
              this.searchDriver();
              this.showDriversLocationInMap();
            })
            .catch(() => {
              this.isLoading = false;
            });
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Location Service Error!',
            text: error.response?.data?.message
          });
        });
    },
    showDriversLocationInMap() {
      if (this.activeDriverList?.length > 0) {
        let bounds = new this.google.maps.LatLngBounds();

        this.activeDriverList.forEach((driverLoc) => {
          let positionDriver = {
            lat: +driverLoc.lat,
            lng: +driverLoc.lon
          };
          let icon = {
            url: 'https://www.shareicon.net/data/128x128/2016/01/15/703693_gps_512x512.png',
            scaledSize: new this.google.maps.Size(35, 35)
            // origin: new this.google.maps.Point(0, 0)
            // anchor: new this.google.maps.Point(0, 0)
          };
          let driverDetails = this.driverDetailsObj[driverLoc.userCode]
            ? this.driverDetailsObj[driverLoc.userCode]
            : null;
          let driverName = driverDetails ? driverDetails.name : 'N/A';
          let driverMobile = driverDetails ? driverDetails.mobile : 'N/A';
          let title = driverName + '  ' + driverMobile;
          const contentString =
            '<div>' +
            '<h6 style="font-size: 16px; padding: 0px 0px 0px 0px">' +
            driverName +
            '</h6>' +
            '<div id="bodyContent">' +
            '<p style="margin-bottom: 0"><b>' +
            driverMobile +
            '</b></p>' +
            '</div>' +
            '</div>';
          let marker = new this.google.maps.Marker({
            position: positionDriver,
            animation: this.google.maps.Animation.DROP,
            map: this.map,
            userCode: driverLoc.userCode,
            icon: icon,
            title: title,
            name: driverName,
            mobile: driverMobile
          });
          marker.addListener('click', () => {
            this.infoWindow.close();
            this.infoWindow.setContent(contentString);
            this.infoWindow.open({
              anchor: marker,
              map: this.map,
              shouldFocus: false
            });
          });

          bounds.extend(marker.position);
          this.markers.push(marker);
        });
        this.map.fitBounds(bounds);
      }
    },
    syncBackupTRs(backupTRs) {
      this.selectedBackupTR = backupTRs;
      // To refresh components
      this.backupTRKey += 1;
      this.invitePartnersToBackupTRKey += 1;
    },
    searchInPartnerPage() {
      localStorage.setItem('searchDriverFromPartnerPage', true);
      this.$router.push('/trip-request/partners');
    },
    zoomDriver(userCode) {
      this.infoWindow.close();
      let markers = this.markers;
      markers.forEach((marker) => {
        if (marker.userCode == userCode) {
          const contentString =
            '<div>' +
            '<h6 style="font-size: 16px; padding: 0px 0px 0px 0px">' +
            marker.name +
            '</h6>' +
            '<div id="bodyContent">' +
            '<p style="margin-bottom: 0"><b>' +
            marker.mobile +
            '</b></p>' +
            '</div>' +
            '</div>';

          this.infoWindow = new this.google.maps.InfoWindow({
            content: contentString,
            maxWidth: 200
          });

          this.infoWindow?.open({
            map: this.map,
            anchor: marker,
            shouldFocus: false
          });
          this.google.maps.event.trigger(this.map, 'resize');
          this.map.panTo(marker.getPosition());
          this.map.setZoom(14);
        }
      });
    },
    mapCarInfoIntoObject() {
      this.driverCarInfoObj = {};
      this.driverCarInfos.forEach((driverCarInfo) => {
        this.driverCarInfoObj[driverCarInfo.driver_code] =
          driverCarInfo.carType;
      });
    },
    async getDriverCarInfo(driverCodes) {
      await http
        .get(
          `v2/partners/carInfo/forDrivers?driver_codes=${driverCodes.join(',')}`
        )
        .then((response) => {
          this.driverCarInfos = response.data.data;
          this.mapCarInfoIntoObject();
        })
        .catch((error) => {
          this.$partnerSwal.errorToast.fire({
            title: 'Error getting car info!',
            text: error.response?.data?.message
          });
        });
    },
    searchDriver() {
      this.checkedDriverDetails = [];
      this.filteredActiveDriverList = this.activeDriverList;

      if (this.formValue.driverCode) {
        this.filteredActiveDriverList = this.activeDriverList.filter(
          (activeDriver) => {
            return (
              typeof activeDriver.userCode === 'string' &&
              activeDriver.userCode
                .toLowerCase()
                .indexOf(this.formValue.driverCode.toLowerCase()) > -1
            );
          }
        );

        if (this.filteredActiveDriverList.length === 1) {
          this.zoomDriver(this.filteredActiveDriverList[0].userCode);
        }
      }
    },
    getAreaList() {
      http
        .get('v2/settings/areas')
        .then((response) => {
          this.areaList = response.data?.data;
        })
        .catch((error) => {
          this.$partnerSwal.errorToast.fire({
            title: 'Failed to get area list!',
            text: error.response?.data?.message
          });
        });
    },
    async getUsersFromGarageLocation() {
      await http
        .post('v2/users/from/garage-location', {
          garage_location: this.formValue.garageLocation
        })
        .then((response) => {
          let userCodes = response?.data?.data ? response.data.data : [];
          this.activeDriverList = this.activeDriverList.filter((driver) => {
            return userCodes.includes(driver.userCode);
          });
        })
        .catch((error) => {
          this.$partnerSwal.errorToast.fire({
            title: "Can't search users!",
            text: error.response?.data?.message
          });
        });
    },
    async getGarageLocationsFromUsers(driverCodes) {
      await http
        .post('v2/garage-location/from/users', {
          user_ids: driverCodes
        })
        .then((response) => {
          this.driverGarageLocations = response?.data?.data
            ? response.data.data
            : {};
        })
        .catch((error) => {
          this.$partnerSwal.errorToast.fire({
            title: 'Error getting drivers garage locations!',
            text: error.response?.data?.message
          });
        });
    }
  }
};
</script>

<style scoped>
.page-content {
  position: relative;
}
.button-area button {
  margin-left: 8px;
}
.info-row {
  display: block;
}
.partner-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.partner-card .card-body {
  padding-bottom: 0;
}
.partner-modal-info .info-row {
  padding: 8px 0;
}
ul,
p {
  margin: 0 !important;
  padding: 0;
}
.partner-modal-info ul li {
  list-style: none;
  font-size: 13px;
  padding-left: 22px;
}
.partner-modal-info ul li:first-child {
  padding-left: 0;
}
.partner-modal-info ul li input[type='checkbox'] {
  margin-right: 10px;
  display: table-cell;
  vertical-align: middle;
}
.list-of-drivers {
  float: left;
  width: 336px;
  height: 100%;
}
.list-of-drivers .partner-card {
  height: 100%;
}
.list-of-drivers .partner-card .card-body {
  height: 90%;
  overflow: auto;
}
.list-right-text {
  float: right;
}
.backup-request-btn-holder {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.backup-request-btn-holder button {
  margin-top: 3px;
}
.map-holder {
  height: 100%;
  margin-left: 360px;
  position: relative;
}
#mapId {
  height: 100%;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  border-radius: 8px;
}
.page-content {
  height: 100%;
}
.search-fields {
  width: 100%;
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  position: absolute;
  z-index: 10;
  top: 65px;
}
.sidebar-toggle-btn {
  display: none;
}
.search-fields select,
.search-fields button,
.search-fields input {
  margin: 0 10px 10px 10px;
}

@media only screen and (max-width: 992px) {
  .sidebar-toggle-btn {
    display: inline-block;
  }
  .map-holder {
    margin-left: 0;
  }
  .list-of-drivers {
    width: 0;
  }
  .show-driver-list {
    width: 336px !important;
    position: absolute;
    z-index: 20;
    padding-bottom: 24px;
    transition: 0.5s;
  }
}
</style>
